module.exports = __webpack_public_path__ + "static/mushrooms-f7e59dc7d035c8450d9e8fc0faa9f714.png";